import React, {useCallback, useMemo} from "react";
const {Helmet} = require("react-helmet");

const styles = require("../styles/index.module.scss");
import {ArticleLayout} from "../components/articleLayout/articleLayout";
import {MoreArticles} from "../components/moreArticles/moreArticles";
import Layout from "../components/layout/layout";
import useIndexData from "../components/indexData";
import {ArticleLongData, ArticlesList, Jumbo, KnowledgeBasePost, StrapiLayout} from "@klear/open-site";
import {footerData} from "../components/footerData";


const postsPerComponent = 3;
const postInLongList = 100;
const postsInList = 10;

declare global {
    interface Document {
        documentMode: number;
    }
}

export default () => {
    const {coronas, reports, featuredUpdate, products, strategies, featuredStrategy, allBlogPosts, strapiFooter} = useIndexData();
    const indexFeaturedUpdate = featuredUpdate.edges;
    const indexReports = reports.edges;
    const indexCoronas = coronas.edges;
    const indexProducts = products.edges;
    const indexFeaturedStrategy = featuredStrategy.edges;
    const indexStrategies = strategies.edges;
    const indexAllBlogPosts = allBlogPosts.edges;

    let explorerBrowser = false;
    if (typeof document !== "undefined"){
        explorerBrowser = !!document.documentMode;
    }


    if (typeof window !== "undefined") {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        if (searchParams.get('utm_source') !== null) {
            localStorage.setItem('final_source', searchParams.get('utm_source') as string);
            if (localStorage.getItem('first_source') === null) {
                localStorage.setItem('first_source', searchParams.get('utm_source') as string);
            }
        }
    }

    const ArticlesListData = useCallback((posts) => {
        const data: Array<ArticleLongData> = [];
        posts.forEach((blog) => {
            data.push({slug: blog.node.slug,imageUrl: blog.node.featured_media.source_url, title: blog.node.title, description: blog.node.excerpt});
        });
        return data;
    }, []);


    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>Influencer Marketing Blog | Klear</title>
                <meta name="description"
                      content="Get the latest industry news and trends, and learn influencer marketing best practices from Klear experts."/>
            </Helmet>
            <Layout>
                <div className={styles.container}>
                    {!explorerBrowser  ?
                    <>
                        <Jumbo topImage="https://klear.com/images/new/blogHeader.gif" title="Welcome to the Klear Blog"
                                subTitle="Get the latest industry news and trends, and learn influencer marketing best practices from Klear experts"/>
                        <MoreArticles
                            mainTitle="Reports"
                            sideTitle="More things we’ve learned from data"
                            sectionIcon="https://klear.com/images/new/why-klear/icon-blogReports_200x200.png"
                            posts={indexReports.slice(0, postsPerComponent)}
                            isCategoryPage={false}
                            isLink={true}
                        />
                        <ArticleLayout
                            isHorizontal={true}
                            sectionIcon="https://klear.com/images/new/why-klear/icon-blogKlear_200x200.png"
                            mainTitle="Klear Updates"
                            sideTitle="More things happening on Klear"
                            featured={indexFeaturedUpdate[0].node}
                            posts={indexProducts.slice(1, postsPerComponent + 1)}
                        />
                        <ArticleLayout
                            isHorizontal={true}
                            sectionIcon="https://klear.com/images/new/why-klear/icon-blogStrategy_200x200.png"
                            mainTitle="Strategy" sideTitle="More Influencer Marketing strategy stories"
                            featured={indexFeaturedStrategy[0].node}
                            posts={indexStrategies.slice(0, postsPerComponent)}
                        />
                        <MoreArticles
                            mainTitle="COVID_19"
                            sectionIcon="https://klear.com/images/new/why-klear/icon-blogVirus_200x200.png"
                            posts={indexCoronas.slice(0, postsPerComponent)}
                            isCategoryPage={false}
                            isLink={false}
                        />
                        <ArticlesList
                            mainTitle="All Articles"
                            sideTitle={"Never Miss a Thing"}
                            posts={ArticlesListData(indexAllBlogPosts.slice(0, postsInList))}
                        />
                    </>
                        :
                        <span>
                            <ArticlesList
                                mainTitle="All articles"
                                sideTitle={undefined }
                                posts={ArticlesListData(indexAllBlogPosts.slice(0, postInLongList))}
                            />
                        </span>
                    }
                </div>
            </Layout>
        </StrapiLayout>
    );
};